export enum ENUM_AUTH_TOKENS {
  STORAGE_KEY = "authTokens",
  ACCESS_TOKEN = "accessToken",
  REFRESH_TOKEN = "refreshToken",
  DEVICE_ID = "deviceId",
  REMEMBERME = "rememberMe",
  REMEMBERED_EMAIL = "email",
  IMPERSONATION_META = "impersonationMeta",
}

export enum LOGOUT_USER_ACTION {
  NAME = "USER_LOGOUT",
}
